export enum SystemIdentifier {
  General = 0,
  Saas = 1,
  Franquias = 2,
  MeeConsultivo = 3,
  Command = 4
}
